import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { SublocationService } from '../../../services/sublocation.service';


@Component({
  selector: 'app-sublocation-picker',
  templateUrl: './sublocation-picker.component.html',
  styleUrls: ['./sublocation-picker.component.scss']
})
export class SublocationPickerComponent implements OnInit, OnChanges {
  @Input() locationId: number;
  @Input() sublocationId: number;
  @Input() hideIfEmpty: boolean = false;
  @Input() triggerUpdate: boolean = false;
  @Input() _placeholder: string = 'Please Select';
  @Output() onSublocationIdSet = new EventEmitter<number>();
  @Output() onSublocationSet = new EventEmitter<any>();

  sublocations = [];
  sublocationsList = [];


  constructor(public sublocationService: SublocationService) {
  }

  ngOnInit(): void {
    this.LoadSublocations();
  }
  LoadSublocations() {
    console.log(this.locationId);
    if (this.locationId == undefined && this.sublocationId == undefined) {

      this.sublocations = [];
      this.sublocationsList = [];
      return;
    }
    this.sublocationService.getAll().then((sublocations) => {
      this.sublocations = sublocations;
      this.sublocationsList = sublocations;

      if (this.sublocationId != undefined && this.sublocationId != undefined) {
        var location = this.sublocations.find(a => a.id == this.sublocationId);
        this._placeholder = location.name;

      }

      if ((this.locationId != undefined && this.locationId != undefined) && (this.sublocations != undefined && this.sublocations != undefined)) {
        this.sublocations = this.sublocationsList.filter(c => {
          return c.location_Id == this.locationId;
        });
      }

    });

  }
  ngOnChanges(changes: SimpleChanges): void {
        console.log("sublocation picker");
        console.log(changes);

    if ((changes.triggerUpdate != null && changes.triggerUpdate.currentValue!= null)) {

    this.LoadSublocations();

    }

    if ((changes.sublocationId != null && changes.sublocationId.currentValue != null)) {

      if ((this.sublocationId != undefined && this.sublocationId != undefined) && (this.sublocations != undefined && this.sublocations != undefined)) {
        var location = this.sublocations.find(a => a.id == this.sublocationId);
        this._placeholder = location.name;
      }
    }

    if ((changes.locationId != null && changes.locationId.currentValue != null)) {
      this.locationId = changes.locationId.currentValue;

      if ((this.locationId != undefined && this.locationId != undefined) && (this.sublocations != undefined && this.sublocations != undefined)) {
            this.LoadSublocations();
        this.sublocations = this.sublocationsList.filter(c => {
          return c.location_Id == this.locationId;
        });
      }
    }
  }

  onChanged(sublocation) {
    if (sublocation) {
      this.onSublocationIdSet.emit(sublocation.id);
    }
    this.onSublocationSet.emit(sublocation);


  }

}
